import { jsx as _jsx } from "react/jsx-runtime";
import { Root, IconButton } from "./IconButtonGroup.components.js";
export const IconButtonGroupAtomComponent = ({ data, ...props }) => {
    if (!data.length)
        return null;
    return (_jsx(Root, { "data-testid": "IconButtonGroup", ...props, children: data.map((iconButtonProps, index) => (_jsx(IconButton, { "data-testid": "IconButtonGroupIconButton", ...iconButtonProps }, index))) }));
};
export default IconButtonGroupAtomComponent;
